import { render, staticRenderFns } from "./wyjj.vue?vue&type=template&id=be01167e&scoped=true&"
import script from "./wyjj.vue?vue&type=script&lang=js&"
export * from "./wyjj.vue?vue&type=script&lang=js&"
import style0 from "./wyjj.vue?vue&type=style&index=0&id=be01167e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be01167e",
  null
  
)

export default component.exports